import { useUIStore } from '@/config/stores/ui-store';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getFriendsWithPresence } from '../services/contacts.service';
import { contactKeys } from './contact-key';

/**
 * Hook to fetch friends with presence status
 * Automatically loads friends on mount and updates UI store
 */
export const useGetFriendsWithPresence = () => {
  const { setFriends } = useUIStore();

  const query = useQuery({
    queryKey: contactKeys.friendsWithPresence(),
    queryFn: () => getFriendsWithPresence(),
    staleTime: 5 * 60 * 1000, // 5 minutes - matches server cache TTL
    retry: 1,
    refetchOnWindowFocus: false
  });

  // Update UI store when friends data is loaded
  useEffect(() => {
    if (query.data && query.isSuccess) {
      setFriends(query.data);
    }
  }, [query.data, query.isSuccess, setFriends]);

  return query;
};
